import { render } from "./FilterSidebar.vue?vue&type=template&id=527bf2c2&scoped=true"
import script from "./FilterSidebar.vue?vue&type=script&lang=js"
export * from "./FilterSidebar.vue?vue&type=script&lang=js"

import "./FilterSidebar.vue?vue&type=style&index=0&id=527bf2c2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527bf2c2"]])

export default __exports__